module.exports = __webpack_public_path__ + "media/bootstrap-icons/list-check-abf26a62.svg";